import { render, staticRenderFns } from "./homeView.vue?vue&type=template&id=67dfd494&scoped=true"
import script from "./homeView.vue?vue&type=script&lang=js"
export * from "./homeView.vue?vue&type=script&lang=js"
import style0 from "./homeView.vue?vue&type=style&index=0&id=67dfd494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dfd494",
  null
  
)

export default component.exports